<template>
  <div class="home">
    <div class="page-wraper">
      <!-- Header -->
      <header class="header transparent">
        <div class="main-bar">
          <div class="container">
            <div class="header-content">
              <div class="left-content">
                <!--  <a href="javascript:void(0);" class="menu-toggler">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.4"
                      d="M16.0755 2H19.4615C20.8637 2 22 3.14585 22 4.55996V7.97452C22 9.38864 20.8637 10.5345 19.4615 10.5345H16.0755C14.6732 10.5345 13.537 9.38864 13.537 7.97452V4.55996C13.537 3.14585 14.6732 2 16.0755 2Z"
                      fill="#a19fa8"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                      fill="#a19fa8"
                    />
                  </svg>
                </a> -->
                <transition appear name="slide-fade">
                  <a
                    v-if="nombre_ruta != 'Dashboard'"
                    @click="$router.go(-1)"
                    href="javascript:void(0)"
                    class="text-orange fw-bold boton_atras"
                  >
                    <i class="bx bx-chevron-left bx-lg"></i>
                  </a>
                </transition>
              </div>
              <div class="mid-content">
                <router-link to="/" aria-controls="offcanvasBottom">
                  <img src="assets/images/logo/logo-sm.png" class="mx-auto" style="max-width:100px" />
                </router-link>
              </div>
              <div class="right-content"></div>
            </div>
          </div>
        </div>
      </header>
      <!-- Header End -->
      <!-- Preloader -->
      <div v-if="loading" id="preloader">
        <div class="spinner"></div>
      </div>
      <!-- Preloader end-->
      <!-- Sidebar -->
      <div class="sidebar">
        <div class="author-box">
          <div class="dz-media">
            <img
              src="assets/images/user.png"
              class="rounded-circle"
              alt="author-image"
            />
          </div>
          <div class="dz-info">
            <span>Hola</span>
            <h5 class="name">{{ usuario.nombres }}</h5>
          </div>
        </div>
        <ul class="nav navbar-nav">
          <li class="nav-label">Menu</li>
          <li v-on:click="menu_toggler">
            <router-link class="nav-link" to="/">
              <span class="dz-icon bg-orange light">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.14373 20.7821V17.7152C9.14372 16.9381 9.77567 16.3067 10.5584 16.3018H13.4326C14.2189 16.3018 14.8563 16.9346 14.8563 17.7152V20.7732C14.8562 21.4473 15.404 21.9951 16.0829 22H18.0438C18.9596 22.0023 19.8388 21.6428 20.4872 21.0007C21.1356 20.3586 21.5 19.4868 21.5 18.5775V9.86585C21.5 9.13139 21.1721 8.43471 20.6046 7.9635L13.943 2.67427C12.7785 1.74912 11.1154 1.77901 9.98539 2.74538L3.46701 7.9635C2.87274 8.42082 2.51755 9.11956 2.5 9.86585V18.5686C2.5 20.4637 4.04738 22 5.95617 22H7.87229C8.19917 22.0023 8.51349 21.8751 8.74547 21.6464C8.97746 21.4178 9.10793 21.1067 9.10792 20.7821H9.14373Z"
                    fill="#130F26"
                  />
                </svg>
              </span>
              <span>Inicio</span>
            </router-link>
          </li>
          <li v-on:click="menu_toggler">
            <router-link to="/categorias" class="nav-link">
              <span class="dz-icon bg-orange light">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="svg-main-icon"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <rect
                      fill="#ff6700"
                      x="4"
                      y="4"
                      width="7"
                      height="7"
                      rx="1.5"
                    />
                    <path
                      d="M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z"
                      fill="#fff"
                      opacity="0.5"
                    />
                  </g>
                </svg>
              </span>
              <span>Categorías</span>
            </router-link>
          </li>
          <li v-on:click="menu_toggler">
            <router-link to="/perfil" class="nav-link">
              <span class="dz-icon bg-orange light">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="svg-main-icon"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <polygon points="0 0 24 0 24 24 0 24" />
                    <path
                      d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                      fill="#fff"
                      fill-rule="nonzero"
                      opacity="0.3"
                    />
                    <path
                      d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                      fill="#fff"
                      fill-rule="nonzero"
                    />
                  </g>
                </svg>
              </span>
              <span>Perfil</span>
            </router-link>
          </li>

          <li v-on:click="menu_toggler">
            <a @click="solcitud_plataforma()" class="nav-link">
              <span class="dz-icon bg-orange light">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M2 7v1l11 4 9-4V7L11 4z"></path><path d="M4 11v4.267c0 1.621 4.001 3.893 9 3.734 4-.126 6.586-1.972 7-3.467.024-.089.037-.178.037-.268V11L13 14l-5-1.667v3.213l-1-.364V12l-3-1z"></path></svg>
              </span>
              <span>Solicitar Acceso a Plataforma Educativa</span>
            </a>
          </li>

          <hr />
          <li>
            <a
              v-on:click="set_logout()"
              class="nav-link"
              href="javascript:void(0)"
            >
              <span class="dz-icon bg-orange light">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="svg-main-icon"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <path
                      d="M14.0069431,7.00607258 C13.4546584,7.00607258 13.0069431,6.55855153 13.0069431,6.00650634 C13.0069431,5.45446114 13.4546584,5.00694009 14.0069431,5.00694009 L15.0069431,5.00694009 C17.2160821,5.00694009 19.0069431,6.7970243 19.0069431,9.00520507 L19.0069431,15.001735 C19.0069431,17.2099158 17.2160821,19 15.0069431,19 L3.00694311,19 C0.797804106,19 -0.993056895,17.2099158 -0.993056895,15.001735 L-0.993056895,8.99826498 C-0.993056895,6.7900842 0.797804106,5 3.00694311,5 L4.00694793,5 C4.55923268,5 5.00694793,5.44752105 5.00694793,5.99956624 C5.00694793,6.55161144 4.55923268,6.99913249 4.00694793,6.99913249 L3.00694311,6.99913249 C1.90237361,6.99913249 1.00694311,7.89417459 1.00694311,8.99826498 L1.00694311,15.001735 C1.00694311,16.1058254 1.90237361,17.0008675 3.00694311,17.0008675 L15.0069431,17.0008675 C16.1115126,17.0008675 17.0069431,16.1058254 17.0069431,15.001735 L17.0069431,9.00520507 C17.0069431,7.90111468 16.1115126,7.00607258 15.0069431,7.00607258 L14.0069431,7.00607258 Z"
                      fill="#fff"
                      fill-rule="nonzero"
                      opacity="0.3"
                      transform="translate(9.006943, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-9.006943, -12.000000) "
                    />
                    <rect
                      fill="#ff6700"
                      opacity="0.3"
                      transform="translate(14.000000, 12.000000) rotate(-270.000000) translate(-14.000000, -12.000000) "
                      x="13"
                      y="6"
                      width="2"
                      height="12"
                      rx="1"
                    />
                    <path
                      d="M21.7928932,9.79289322 C22.1834175,9.40236893 22.8165825,9.40236893 23.2071068,9.79289322 C23.5976311,10.1834175 23.5976311,10.8165825 23.2071068,11.2071068 L20.2071068,14.2071068 C19.8165825,14.5976311 19.1834175,14.5976311 18.7928932,14.2071068 L15.7928932,11.2071068 C15.4023689,10.8165825 15.4023689,10.1834175 15.7928932,9.79289322 C16.1834175,9.40236893 16.8165825,9.40236893 17.2071068,9.79289322 L19.5,12.0857864 L21.7928932,9.79289322 Z"
                      fill="#fff"
                      fill-rule="nonzero"
                      transform="translate(19.500000, 12.000000) rotate(-90.000000) translate(-19.500000, -12.000000) "
                    />
                  </g>
                </svg>
              </span>
              <span>Cerrar sesión</span>
            </a>
          </li>
        </ul>
        <div class="sidebar-bottom">
          <h6 class="name text-muted">Reddy App</h6>
          <p class="text-muted">App Version 1.0</p>
        </div>
      </div>
      <!-- Sidebar End -->
      <!-- Banner -->
      <div v-if="nombre_ruta != 'Aliado_n'"  class="banner-wrapper author-notification">
        <div class="container inner-wrapper">
          <div class="dz-info">
            <span>Hola</span>
            <h2 class="name mb-0 text-capitalize">{{ usuario.nombres }}</h2>
          </div>
          <div class="dz-media media-45 rounded-circle">
            <router-link to="/perfil"
              ><img
                :src="usuario.avatar"
                class="rounded-circle"
                alt="author-image"
                width="45"
                height="45"
            /></router-link>
          </div>
        </div>
      </div>
      <!-- Banner End -->
      <!-- Page Content -->
      <div class="page-content">
        <div v-bind:class="{'content-inner pt-0':nombre_ruta!='Aliado_n', 'content-body fb':nombre_ruta=='Aliado_n'}">
          <div v-bind:class="{'container fb':nombre_ruta!='Aliado_n'}">
            
            <!-- Search -->
            <form v-if="nombre_ruta != 'Aliado_n'">
              <div class="input-group" v-if="this.$route.path !== '/perfil'">
                <span class="input-group-text">
                  <a href="javascript:void(0);" class="search-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20.5605 18.4395L16.7528 14.6318C17.5395 13.446 18 12.0262 18 10.5C18 6.3645 14.6355 3 10.5 3C6.3645 3 3 6.3645 3 10.5C3 14.6355 6.3645 18 10.5 18C12.0262 18 13.446 17.5395 14.6318 16.7528L18.4395 20.5605C19.0245 21.1462 19.9755 21.1462 20.5605 20.5605C21.1462 19.9748 21.1462 19.0252 20.5605 18.4395ZM5.25 10.5C5.25 7.605 7.605 5.25 10.5 5.25C13.395 5.25 15.75 7.605 15.75 10.5C15.75 13.395 13.395 15.75 10.5 15.75C7.605 15.75 5.25 13.395 5.25 10.5Z"
                        fill="#B9B9B9"
                      />
                    </svg>
                  </a>
                </span>
                <input
                  v-model="search"
                  v-on:keyup="get_search"
                  type="text"
                  placeholder="Buscar..."
                  class="form-control ps-0 bs-0"
                />
              </div>
            </form>

            <router-view
              :session="session"
              :loading_search="loading_search"
              :search="search"
              :aliados_search="aliados_search" 
              :ciudad="ciudad"
            />
          </div>
        </div>
      </div>
      <!-- Page Content End-->

      <!-- Menubar -->
      <div class="menubar-area">
        <div class="toolbar-inner menubar-nav">
          <router-link to="/" class="nav-link active">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.14373 20.7821V17.7152C9.14372 16.9381 9.77567 16.3067 10.5584 16.3018H13.4326C14.2189 16.3018 14.8563 16.9346 14.8563 17.7152V20.7732C14.8562 21.4473 15.404 21.9951 16.0829 22H18.0438C18.9596 22.0023 19.8388 21.6428 20.4872 21.0007C21.1356 20.3586 21.5 19.4868 21.5 18.5775V9.86585C21.5 9.13139 21.1721 8.43471 20.6046 7.9635L13.943 2.67427C12.7785 1.74912 11.1154 1.77901 9.98539 2.74538L3.46701 7.9635C2.87274 8.42082 2.51755 9.11956 2.5 9.86585V18.5686C2.5 20.4637 4.04738 22 5.95617 22H7.87229C8.19917 22.0023 8.51349 21.8751 8.74547 21.6464C8.97746 21.4178 9.10793 21.1067 9.10792 20.7821H9.14373Z"
                fill="#130F26"
              />
            </svg>
          </router-link>
          <router-link to="/favoritos" class="nav-link">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.4"
                d="M11.776 21.8374C9.49294 20.4273 7.37064 18.7645 5.44791 16.8796C4.09052 15.5338 3.05388 13.8905 2.41718 12.0753C1.27955 8.53523 2.60383 4.48948 6.30113 3.2884C8.25264 2.67553 10.3751 3.05175 12.0071 4.29983V4.29983C13.6397 3.05315 15.7614 2.67705 17.713 3.2884C21.4103 4.48948 22.7435 8.53523 21.6058 12.0753C20.9743 13.8888 19.9438 15.5319 18.5929 16.8796C16.6684 18.7625 14.5463 20.4251 12.2648 21.8374L12.016 22L11.776 21.8374Z"
                fill="#a19fa8"
              />
              <path
                d="M12.0109 22L11.776 21.8374C9.49013 20.4274 7.36487 18.7647 5.43902 16.8796C4.0752 15.5356 3.03238 13.8922 2.39052 12.0753C1.26177 8.53523 2.58605 4.48948 6.28335 3.2884C8.23486 2.67553 10.3853 3.05204 12.0109 4.31057V22Z"
                fill="#a19fa8"
              />
              <path
                d="M18.2304 9.99922V9.99922C18.0296 9.98629 17.8425 9.8859 17.7131 9.72157C17.5836 9.55723 17.5232 9.3434 17.5459 9.13016V9.13016C17.5677 8.4278 17.168 7.78851 16.5517 7.53977C16.1609 7.43309 15.9243 7.00987 16.022 6.59249C16.1148 6.18182 16.4993 5.92647 16.8858 6.0189C16.9346 6.027 16.9816 6.04468 17.0244 6.07105C18.2601 6.54658 19.0601 7.82641 18.9965 9.22576C18.9944 9.43785 18.9117 9.63998 18.7673 9.78581C18.6229 9.93164 18.4291 10.0087 18.2304 9.99922Z"
                fill="#a19fa8"
              />
            </svg>
          </router-link>
          <a   href="https://api.whatsapp.com/send?phone=573195566987"  class="nav-link">
            
             <i class="fab fa-whatsapp" style="color: #a19fa8; font-size:24px; font-weight:bold"></i>
          </a>
          <a href="javascript:void(0);" class="menu-toggler">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.4"
                d="M16.0755 2H19.4615C20.8637 2 22 3.14585 22 4.55996V7.97452C22 9.38864 20.8637 10.5345 19.4615 10.5345H16.0755C14.6732 10.5345 13.537 9.38864 13.537 7.97452V4.55996C13.537 3.14585 14.6732 2 16.0755 2Z"
                fill="#a19fa8"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                fill="#a19fa8"
              />
            </svg>
          </a>
        </div>
      </div>
      <!-- Menubar -->
      <div class="contBtnWhatsapp">
        <button class="botonF1">
          <span>
            <router-link to="/leer_qr" >
              <span><i class="bx bx-qr-scan bx-sm" style="color: #fff"></i></span>
            </router-link>
          </span>
        </button>
      </div>
    </div>
    <!-- Modal Educacion -->
    <modal name="modal-educacion" :adaptive="true" height="320">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-danger">Solicitud Plataforma Educativa</h4>
        </div>
        <div class="card-body">
          <p>En el transcurso de los siguientes 3 dás habiles recibiras un correo con el link de acceso y las credeciales para que puedas hacer uso de este servicio.</p>
          <hr />
          <div class="text-end">
            <button
              @click="$modal.hide('modal-educacion')"
              class="btn btn-outline-secondary rounded-pill"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- Fin Modal Educacion -->
  </div>
</template>
<script>
import axios from "axios";
import $ from "jquery";
export default {
  name: "Home",
  data() {
    return {
      loading: true,
      session: null,
      usuario: null,
      search: null,
      loading_search: false,
      aliados_search: null,
      nombre_ruta: null,
      ciudad:null
    };
  },
  created: function () {
    var session = localStorage.getItem("sess_reddy_app");
    if (session == undefined) {
      this.$router.push("/auth");
    } else {
      session = JSON.parse(session);
      this.session = session;
      this.usuario = session.usuario;
      this.loading = false;
    }
    let ciudad = localStorage.getItem("ciudad");
    if(ciudad!=undefined){
      this.ciudad = JSON.parse(ciudad);
    }
    localStorage.removeItem("aliado_qr");
    this.nombre_ruta = this.$route.name;
  },
  methods: {
    solcitud_plataforma(){
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          email: this.usuario.email,
        },
      };
      const vm = this;
      axios
        .post(this.$base_url + "admin/solicitud_educacion", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          }
          this.$modal.show('modal-educacion')
          console.log('solicitud procesada')
        })
        .catch((error) =>{
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Oye!",
            text: 'ya tienes una solicitud realizada',
          })
          console.log(error)
        })
        .finally();
    },
    get_search: function () {
      if (this.$route.name != "Buscar") {
        this.$router.push("/buscar");
      }
      this.get_aliados_search();
    },
    get_aliados_search: function () {
      if (
        this.search == null ||
        this.search.trim().length == 0 ||
        this.search.trim().length < 3
      ) {
        this.aliados_search = null;
        this.loading_search = false;
        return false;
      }
      this.loading_search = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          search: this.search,
        },
      };
      const vm = this;
      axios
        .get(this.$base_url + "aliados/aliados_app", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            this.aliados_search = response.data.data.aliados;
            this.loading_search = false;
          }
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
    menu_toggler: function () {
      $(".sidebar").toggleClass("show");
      $(".menu-toggler").toggleClass("show");
    },
    set_logout: function () {
      localStorage.removeItem("sess_reddy_app");
      location.reload();
    },
  },
  mounted: function () {
    // Menubar Toggler
    $(".menu-toggler").on("click", function () {
      $(".sidebar").toggleClass("show");
    });

    $(".menu-toggler").on("click", function () {
      $(".menu-toggler").toggleClass("show");
    });

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 50) {
        $(".main-bar").addClass("sticky-header");
      } else {
        $(".main-bar").removeClass("sticky-header");
      }
    });

    $(".menubar-nav .nav-link").on("click", function () {
      $(".menubar-nav .nav-link").removeClass("active");
      $(this).addClass("active");
    });

    $(".dz-treeview-item").on("click", function () {
      $(this).toggleClass("open");
    });
  },
  watch: {
    $route() {
      this.nombre_ruta = this.$route.name;
      let ciudad = localStorage.getItem("ciudad");
      if(ciudad!=undefined){
        this.ciudad = JSON.parse(ciudad);
      }
    },
  },
};
</script>
